export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4775.4124b25a.jpg";